module.exports = __webpack_public_path__ + "media/images/ship-72330065f64c9853e652ab603df1268c.png";